module.exports = __webpack_public_path__ + "../resources/img/guideStep2.a7616935.png";